import styled from 'styled-components';
import { WarningAlert } from './Alerts/styles/Alerts.styles';

export const MailingInfo = styled.div<{
  inFooter?: boolean;
  children?: any;
}>`
  display: none;
  ${(props) =>
    props.inFooter &&
    `
    display: block;
  `}
  font-size: 15px;
  line-height: 23px;
  font-weight: 500;
  color: var(--cvna-color-grey-5);
  text-align: center;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    display: block;
    ${(props: any) =>
      props.inFooter &&
      `
      display: none;
    `}
  } ;
`;

export const Label = styled.p`
  text-align: right;
  margin: 0;
  -ms-grid-column: 1;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    text-align: left;
  } ;
`;

export const Value = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: 17px;
  padding-left: 10px;
  text-align: left;
  -ms-grid-column: 2;
  a {
    text-decoration: underline;
    color: var(--cvna-color-grey-5);
    &:hover {
      color: var(--cvna-color-grey-5);
    }
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 0;
  } ;
`;

export const MailedOn = styled.div`
  -ms-grid-row: 1;
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: auto auto;
  grid-template-columns: auto auto;
  align-items: top;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    -ms-grid-columns: 50% 50%;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    -ms-grid-columns: 100px auto;
    grid-template-columns: 100px auto;
  } ;
`;

export const Tracking = styled.div`
  -ms-grid-row: 2;
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: auto auto;
  grid-template-columns: auto auto;
  align-items: top;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    -ms-grid-columns: 100px auto;
    grid-template-columns: 100px auto;
  } ;
`;

export const WarningBox = styled(WarningAlert)`
  margin-bottom: 20px;
`;

export const SelectWarning = styled.p`
  color: var(--cvna-color-red-2);
`;

export const Spacer = styled.div`
  width: 100%;
  height: 0;
  margin-bottom: 40px;
`;

export const Subtitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: left;
  font-size: 14px;
  color: var(--cvna-color-grey-3);

  span {
    color: var(--cvna-color-blue-6);
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
  }
`;

export const EcdContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-bottom: 1.5rem;
  line-height: 1.4em;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
  }
`;

export const EcdSide = styled.div`
  font-weight: 500;
  text-align: left;
  padding: 0 3rem 1.5rem;
`;

export const EcdDates = styled.div`
  color: #008400;
  text-transform: uppercase;
  font-size: 1.4rem;
  font-weight: 600;
  padding-top: 1rem;
  line-height: 1.4em;
`;

export const Disclaimer = styled.div`
  padding: 0 4rem 1.5rem;
  color: #008400;
`;

export const DocUploadArea = styled.div`
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  h3 {
    margin: 0;
  }
`;
